<template>
    <div>
        <CHeading class="mb-3" :variant="3"> Etickosť </CHeading>

        <ul class="mb-8 ml-4 list-outside list-disc space-y-1">
            <li>vzájomne sa rešpektujeme a slušne sa správame bez nenávistných prejavov</li>
            <li>sme zodpovední - "K čomu sa zaviažeme, to dodržíme."</li>
            <li>sme čestní</li>
        </ul>

        <CHeading class="mb-3" :variant="3">Ochrana mladistvých</CHeading>

        <ul class="mb-8 ml-4 list-outside list-disc space-y-1">
            <li>
                Platforma je určená aj pre neplnoletých používateľov. Snažíme sa ich maximálne chrániť. Zneužívanie
                mladistvých ľudí je neprípustné a trestné.
            </li>
        </ul>

        <CHeading class="mb-3" :variant="3">Nestraníckosť & nenáboženskosť</CHeading>

        <ul class="mb-8 ml-4 list-outside list-disc space-y-1">
            <li>
                nepropagujeme žiaden politický smer (pravica/ľavica), politické strany, politických kandidátov či
                náboženstvo
            </li>
            <li>
                neprinášame obsah, ktorý je orientovaný na konkrétnu politickú stranu, politického kandidáta či
                predstavuje konkrétny náboženský smer
            </li>
            <li>ako mentor či mentee sa nesnažíme presviedčať o svojich preferenciách druhú stranu</li>
        </ul>

        <CCardBox class="text-sm" variant="flat">
            V prípade, že uvidíš príspevky iných, ktoré akýmkoľvek spôsobom porušujú pravidlá spomenuté vyššie, prosím,
            daj nám o tom vedieť:
            <a class="link" href="mailto:help@growni.sk" rel="nofollow"> help@growni.sk</a>.
        </CCardBox>
    </div>
</template>

<script setup lang="ts">
import CCardBox from '@/components/ui/CCardBox.vue'
import CHeading from '@/components/ui/CHeading.vue'
</script>
